import { Button, RecordFooter } from '@msaf/core-react'
import { useLocation } from '@msaf/router-react'
import { memo, ReactNode, useState } from 'react'
import { RouteMode } from '../../../../types/route'
import { usePermissionLoading } from '../../../../services/permissions'
import { UserPermissions } from '../../../../types/permissions'
import { DeletePlanModal } from './delete-plan'

interface FooterProps {
  mode: RouteMode
  footerActions?: ReactNode
  nextPath?: string
  canEdit?: boolean
  isDisabled?: boolean
}

export const SAVE_AND_CONTINUE_ID = 'save-and-continue'

export default memo(function ({ mode, footerActions, nextPath, canEdit, isDisabled }: FooterProps) {
  const { pathname } = useLocation()
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const isPlanOverviewRoute = pathname.match('plan/overview')
  const { hasPermission: hasDeletePlanPermission } = usePermissionLoading([UserPermissions.DELETE_PLANS])

  // Early exit if explicitly provided actions
  if (footerActions !== undefined) {
    return <RecordFooter>{footerActions}</RecordFooter>
  }

  const actions = [
    <Button
      key='cancel'
      type='button'
      buttonStyle='text-action'
      path='/'
      label={mode == RouteMode.EDIT ? 'Cancel' : 'Close'}
    />,
  ]

  if (mode === RouteMode.EDIT) {
    const saveAction = <Button key='save' label='Save' type='submit' isDisabled={isDisabled} />
    actions.unshift(saveAction)

    if (nextPath) {
      const saveAndContinueAction = (
        <Button
          key='saveandcontinue'
          label='Save and continue'
          id={SAVE_AND_CONTINUE_ID}
          type='submit'
          isDisabled={isDisabled}
        />
      )
      actions.unshift(saveAndContinueAction)
    }
  } else {
    if (canEdit) {
      actions.unshift(
        <Button key='edit' label='Edit' path={pathname.replace(`/${RouteMode.VIEW}/`, `/${RouteMode.EDIT}/`)} />,
      )
    }
  }

  if (isPlanOverviewRoute && hasDeletePlanPermission) {
    const deletePlanActionButton = (
      <Button
        key='delete'
        label='Delete SRP'
        type='button'
        buttonStyle='danger'
        onClick={() => setIsDeleteModalOpen(true)}
      />
    )
    actions.unshift(deletePlanActionButton)
  }

  return (
    <>
      {isDeleteModalOpen && <DeletePlanModal isOpen={isDeleteModalOpen} setIsOpen={setIsDeleteModalOpen} />}
      <RecordFooter>{actions}</RecordFooter>
    </>
  )
})
